<div class="image-slider">
    <div class="slide" *ngFor="let image of images; let i = index" [ngClass]="{'active': i === currentIndex}">
      <img [src]="image" alt="Image {{ i + 1 }}" />
    </div>
    <div class="slider-buttons">
      <span class="slider-button" *ngFor="let image of images; let i = index" (click)="changeSlide(i)" [ngClass]="{'active': i === currentIndex}"></span>
    </div>
  </div>
  
